module.exports = __webpack_public_path__ + "static/img/app.5cafb455.png";